// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminDashboard_root__v50wq {
  background-color: var(--brand);
  min-height: calc(100vh - 64px);
  width: 100%;
}

.SuperAdminDashboard_pageHeader__CqU\\+\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.28);
  margin-bottom: 16px;
}

.SuperAdminDashboard_pageMain__3gJHS {
  padding: 0 24px 32px;
}

.SuperAdminDashboard_title__qXhGb {
  font: var(--h3);
  font-weight: 700;
  color: var(--white);
  font-family: var(--font-bodoni-72);
  margin: 0;
}

.SuperAdminDashboard_subtitle__fVWGC {
  font: var(--body-font-four);
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 20px;
}

.SuperAdminDashboard_statsGrid__CqETc {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 8px;
}

.SuperAdminDashboard_statCard__Ffy\\+e {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  box-shadow: none;
}

.SuperAdminDashboard_statCardTitle__lvMBq {
  font: var(--body-font-three);
  font-weight: 700;
  color: var(--primary-Text);
  margin: 0 0 16px;
}

.SuperAdminDashboard_statRow__B6q57 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
}
.SuperAdminDashboard_statRow__B6q57:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.SuperAdminDashboard_statRow__B6q57:first-of-type {
  padding-top: 0;
}

.SuperAdminDashboard_statLabel__8OvAl {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin: 0;
}

.SuperAdminDashboard_statValue__6MBx\\+ {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  margin: 0;
}

.SuperAdminDashboard_statsError__YuK8A {
  font: var(--body-font-four);
  color: var(--white);
  margin-top: 12px;
  opacity: 0.95;
}

.SuperAdminDashboard_statsErrorInline__lfrRq {
  font: var(--body-font-four);
  color: var(--error);
  margin: 12px 0 0;
}

.SuperAdminDashboard_chartsGrid__9N97l {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 28px;
  max-width: 1100px;
}

.SuperAdminDashboard_chartCard__By5yJ {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  box-shadow: none;
}

.SuperAdminDashboard_chartCardTitle__JQXpP {
  font: var(--body-font-three);
  font-weight: 700;
  color: var(--primary-Text);
  margin: 0 0 8px;
}

.SuperAdminDashboard_chartCaption__SORJY {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin: 0 0 12px;
}

.SuperAdminDashboard_chartInner__8Rz2m {
  width: 100%;
  min-height: 320px;
}

.SuperAdminDashboard_chartPlaceholder__2emLw {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin: 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/SuperAdminDashboard.module.scss"],"names":[],"mappings":"AAEA;EACC,8BAAA;EACA,8BAAA;EACA,WAAA;AADD;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,mBAAA;AADD;;AAIA;EACC,oBAAA;AADD;;AAIA;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,SAAA;AADD;;AAIA;EACC,2BAAA;EACA,gCAAA;EACA,gBAAA;AADD;;AAIA;EACC,aAAA;EACA,4DAAA;EACA,SAAA;EACA,eAAA;AADD;;AAIA;EACC,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AADD;;AAIA;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,sCAAA;AADD;AAGC;EACC,mBAAA;EACA,iBAAA;AADF;AAIC;EACC,cAAA;AAFF;;AAMA;EACC,2BAAA;EACA,4BAAA;EACA,SAAA;AAHD;;AAMA;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAHD;;AAMA;EACC,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAHD;;AAMA;EACC,2BAAA;EACA,mBAAA;EACA,gBAAA;AAHD;;AAMA;EACC,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAHD;;AAMA;EACC,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAHD;;AAMA;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAHD;;AAMA;EACC,2BAAA;EACA,4BAAA;EACA,gBAAA;AAHD;;AAMA;EACC,WAAA;EACA,iBAAA;AAHD;;AAMA;EACC,2BAAA;EACA,4BAAA;EACA,cAAA;AAHD","sourcesContent":["// Main column: same layout rhythm as user dashboard (pageHeader + pageMain).\r\n// Background matches sidebar .activeNavItem → var(--brand) in global.css\r\n.root {\r\n\tbackground-color: var(--brand);\r\n\tmin-height: calc(100vh - 64px);\r\n\twidth: 100%;\r\n}\r\n\r\n.pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.28);\r\n\tmargin-bottom: 16px;\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px 32px;\r\n}\r\n\r\n.title {\r\n\tfont: var(--h3);\r\n\tfont-weight: 700;\r\n\tcolor: var(--white);\r\n\tfont-family: var(--font-bodoni-72);\r\n\tmargin: 0;\r\n}\r\n\r\n.subtitle {\r\n\tfont: var(--body-font-four);\r\n\tcolor: rgba(255, 255, 255, 0.92);\r\n\tmargin: 0 0 20px;\r\n}\r\n\r\n.statsGrid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n\tgap: 20px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n.statCard {\r\n\tbackground: var(--white);\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 12px;\r\n\tpadding: 20px;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.statCardTitle {\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 700;\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0 0 16px;\r\n}\r\n\r\n.statRow {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 4px;\r\n\tpadding: 12px 0;\r\n\tborder-bottom: 1px solid var(--border);\r\n\r\n\t&:last-child {\r\n\t\tborder-bottom: none;\r\n\t\tpadding-bottom: 0;\r\n\t}\r\n\r\n\t&:first-of-type {\r\n\t\tpadding-top: 0;\r\n\t}\r\n}\r\n\r\n.statLabel {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--secondary-Text);\r\n\tmargin: 0;\r\n}\r\n\r\n.statValue {\r\n\tfont: var(--h3);\r\n\tfont-weight: 700;\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0;\r\n}\r\n\r\n.statsError {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--white);\r\n\tmargin-top: 12px;\r\n\topacity: 0.95;\r\n}\r\n\r\n.statsErrorInline {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--error);\r\n\tmargin: 12px 0 0;\r\n}\r\n\r\n.chartsGrid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 1fr;\r\n\tgap: 20px;\r\n\tmargin-top: 28px;\r\n\tmax-width: 1100px;\r\n}\r\n\r\n.chartCard {\r\n\tbackground: var(--white);\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 12px;\r\n\tpadding: 20px;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.chartCardTitle {\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 700;\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0 0 8px;\r\n}\r\n\r\n.chartCaption {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--secondary-Text);\r\n\tmargin: 0 0 12px;\r\n}\r\n\r\n.chartInner {\r\n\twidth: 100%;\r\n\tmin-height: 320px;\r\n}\r\n\r\n.chartPlaceholder {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--secondary-Text);\r\n\tmargin: 24px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SuperAdminDashboard_root__v50wq`,
	"pageHeader": `SuperAdminDashboard_pageHeader__CqU++`,
	"pageMain": `SuperAdminDashboard_pageMain__3gJHS`,
	"title": `SuperAdminDashboard_title__qXhGb`,
	"subtitle": `SuperAdminDashboard_subtitle__fVWGC`,
	"statsGrid": `SuperAdminDashboard_statsGrid__CqETc`,
	"statCard": `SuperAdminDashboard_statCard__Ffy+e`,
	"statCardTitle": `SuperAdminDashboard_statCardTitle__lvMBq`,
	"statRow": `SuperAdminDashboard_statRow__B6q57`,
	"statLabel": `SuperAdminDashboard_statLabel__8OvAl`,
	"statValue": `SuperAdminDashboard_statValue__6MBx+`,
	"statsError": `SuperAdminDashboard_statsError__YuK8A`,
	"statsErrorInline": `SuperAdminDashboard_statsErrorInline__lfrRq`,
	"chartsGrid": `SuperAdminDashboard_chartsGrid__9N97l`,
	"chartCard": `SuperAdminDashboard_chartCard__By5yJ`,
	"chartCardTitle": `SuperAdminDashboard_chartCardTitle__JQXpP`,
	"chartCaption": `SuperAdminDashboard_chartCaption__SORJY`,
	"chartInner": `SuperAdminDashboard_chartInner__8Rz2m`,
	"chartPlaceholder": `SuperAdminDashboard_chartPlaceholder__2emLw`
};
export default ___CSS_LOADER_EXPORT___;
